import React from "react";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";

const statusOptions = [
  { value: "all", label: "All" },
  { value: "upcoming", label: "Upcoming" },
  { value: "live", label: "Live" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const UpcomingGamesHeader = ({ status, onStatusChange }) => (
  <div className="flex items-center justify-between mb-2">
    <h2 className="text-jp-accent-ink text-sm font-bold uppercase tracking-widest">
      UPCOMING GAMES
    </h2>

    <div className="flex items-center gap-4 text-[11px] text-jp-ink">
      <div className="flex items-center gap-2">
        <span>Status</span>
        <SimpleDropdown
          value={status}
          onChange={onStatusChange}
          options={statusOptions}
          placeholder="All"
          variant="admin"
          buttonClassName="h-7 px-2 pr-7 rounded bg-jp-card border border-jp-line text-[11px] text-jp-ink cursor-pointer flex items-center gap-1.5 whitespace-nowrap"
        />
      </div>
    </div>
  </div>
);
